/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_Company_TitleInputs */

const en_impressum_company_title = /** @type {(inputs: Impressum_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company Information`)
};

const de_impressum_company_title = /** @type {(inputs: Impressum_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angaben zum Unternehmen`)
};

const fr_impressum_company_title = /** @type {(inputs: Impressum_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informations sur l'entreprise`)
};

const es_impressum_company_title = /** @type {(inputs: Impressum_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información de la empresa`)
};

const it_impressum_company_title = /** @type {(inputs: Impressum_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni sull'azienda`)
};

const nl_impressum_company_title = /** @type {(inputs: Impressum_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedrijfsinformatie`)
};

const pl_impressum_company_title = /** @type {(inputs: Impressum_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dane firmy`)
};

const fi_impressum_company_title = /** @type {(inputs: Impressum_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yrityksen tiedot`)
};

const da_impressum_company_title = /** @type {(inputs: Impressum_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virksomhedsoplysninger`)
};

const sv_impressum_company_title = /** @type {(inputs: Impressum_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Företagsinformation`)
};

/**
* | output |
* | --- |
* | "Company Information" |
*
* @param {Impressum_Company_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_company_title = /** @type {((inputs?: Impressum_Company_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_Company_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_company_title(inputs)
	if (locale === "fr") return fr_impressum_company_title(inputs)
	if (locale === "es") return es_impressum_company_title(inputs)
	if (locale === "it") return it_impressum_company_title(inputs)
	if (locale === "nl") return nl_impressum_company_title(inputs)
	if (locale === "pl") return pl_impressum_company_title(inputs)
	if (locale === "fi") return fi_impressum_company_title(inputs)
	if (locale === "da") return da_impressum_company_title(inputs)
	if (locale === "sv") return sv_impressum_company_title(inputs)
	return en_impressum_company_title(inputs)
});